import axios from 'axios'

// Auth-specific client (uses cookies, not token header)
const authClient = axios.create({
  baseURL: '/api/auth',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Important for cookie-based auth
})

export interface TelegramAuthData {
  id: number
  first_name: string
  last_name?: string
  username?: string
  photo_url?: string
  auth_date: number
  hash: string
}

export interface AuthUser {
  id: number
  telegram_id: number
  telegram_username: string | null
  first_name: string | null
  last_name: string | null
  photo_url: string | null
  is_active: boolean
  created_at: string
}

export interface AuthResponse {
  token: string
  user: AuthUser
  expires_at: string
}

export interface AuthMeResponse {
  user: AuthUser
}

// Authenticate with Telegram Login Widget data
export const loginWithTelegram = async (authData: TelegramAuthData): Promise<AuthResponse> => {
  const response = await authClient.post<AuthResponse>('/telegram', authData)
  return response.data
}

// Get current authenticated user
export const getCurrentUser = async (): Promise<AuthMeResponse> => {
  const response = await authClient.get<AuthMeResponse>('/me')
  return response.data
}

// Logout
export const logout = async (): Promise<void> => {
  await authClient.post('/logout')
}

export default authClient
